import BaseModel from './BaseModel'

export default class Role extends BaseModel {
  // ... any Role-specific methods or overrides ...
}
